export interface HaveIBeenPwnedBreach {
    Name: string;
    Title: string;
    Domain: string;
    BreachDate: string;
    AddedDate: string;
    ModifiedDate: string;
    PwnCount: number;
    Description: string;
    LogoPath: string;
    DataClasses: string[];
    IsVerified: boolean;
    IsFabricated: boolean;
    IsSensitive: boolean;
    IsRetired: boolean;
    IsSpamList: boolean;
}

export function isValidPasswordBreach(breach: HaveIBeenPwnedBreach): boolean {
    return breach.DataClasses.includes('Passwords') && breach.IsVerified && !breach.IsFabricated && !breach.IsRetired;
}

export interface PwnedUser {
    tenant_id: string;
    user_id: string;
    email: string;
    name: string;
    breach?: HaveIBeenPwnedBreach[] | null;
}
